import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const OpportunitySVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default OpportunitySVG;
